import { render } from "./new-mobile.html?vue&type=template&id=7570030e&ts=true"
import script from "./new-mobile.vue?vue&type=script&lang=ts"
export * from "./new-mobile.vue?vue&type=script&lang=ts"

import "./new-mobile.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__